import React, { useEffect } from 'react';
import classNames from 'classnames';

interface Props {
	open: boolean;
	close: () => void;
	className: string;
	children: any;
	closeIfClickOutside?: boolean;
}

export default function ModalLarge(props: Props) {
	const {
		open,
		close,
		className,
		children,
		closeIfClickOutside = false
	} = props;

	useEffect(() => {
		if (open && closeIfClickOutside) {
			window.addEventListener('click', handleClick);
		}

		return () => {
			window.removeEventListener('click', handleClick);
		}
	}, [open]);

	function handleClick(e: any) {
		let path = e.composedPath();
		let len = path.length;
		let keepOpen = false;

		for (let i = 0; i < len; ++i) {
			if (path[i].className?.includes) {
				if ((typeof path[i].className === 'string' &&
					path[i].className.includes('modal-large') &&
					!path[i].className.includes('modal-large-overlay'))) {
					keepOpen = true;
					break;
				}
			}
		}
		if (!keepOpen) {
			close();
		}
	}

	return (
		<div className="modal-large-overlay" id="modal-large-overlay">
			<div className={classNames("modal-large", className)}>
				{children}
			</div>
		</div>
	)
}